var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M406.351,0H67.289c-13.73,0-24.9,11.17-24.9,24.9v389.922c0,13.73,11.17,24.9,24.9,24.9h339.062 c13.73,0,24.9-11.17,24.9-24.9V24.9C431.251,11.17,420.081,0,406.351,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M58.813,414.822V24.9c0-13.73,11.17-24.9,24.9-24.9H67.289c-13.73,0-24.9,11.17-24.9,24.9v389.922 c0,13.73,11.17,24.9,24.9,24.9h16.423C69.983,439.721,58.813,428.551,58.813,414.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEDEF"
    },
    d: "M388.604,33.906H84.242c-4.389,0-7.947,3.558-7.947,7.947v356.015c0,4.389,3.558,7.947,7.947,7.947 h304.361c4.827,0,8.741-3.914,8.741-8.741V42.648C397.345,37.82,393.431,33.906,388.604,33.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M143.048,33.906H84.242c-4.389,0-7.947,3.558-7.947,7.947v356.015c0,4.389,3.558,7.947,7.947,7.947 h58.806V33.906z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68727E"
    },
    d: "M92.719,322.109H24.906c-13.73,0-24.9,11.17-24.9,24.9c0,13.73,11.17,24.9,24.9,24.9h67.812 c13.73,0,24.9-11.17,24.9-24.9C117.619,333.279,106.449,322.109,92.719,322.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68727E"
    },
    d: "M92.719,194.961H24.906c-13.73,0-24.9,11.17-24.9,24.9c0,13.73,11.17,24.9,24.9,24.9h67.812 c13.73,0,24.9-11.17,24.9-24.9C117.619,206.131,106.449,194.961,92.719,194.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68727E"
    },
    d: "M24.906,117.612h67.812c13.73,0,24.9-11.17,24.9-24.9s-11.17-24.9-24.9-24.9H24.906 c-13.73,0-24.9,11.17-24.9,24.9S11.176,117.612,24.906,117.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55606E"
    },
    d: "M16.43,347.009c0-13.73,11.17-24.9,24.9-24.9H24.906c-13.73,0-24.9,11.17-24.9,24.9 c0,13.73,11.17,24.9,24.9,24.9H41.33C27.6,371.909,16.43,360.739,16.43,347.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55606E"
    },
    d: "M16.43,219.861c0-13.73,11.17-24.9,24.9-24.9H24.906c-13.73,0-24.9,11.17-24.9,24.9 c0,13.73,11.17,24.9,24.9,24.9H41.33C27.6,244.761,16.43,233.591,16.43,219.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55606E"
    },
    d: "M16.43,92.712c0-13.73,11.17-24.9,24.9-24.9H24.906c-13.73,0-24.9,11.17-24.9,24.9 s11.17,24.9,24.9,24.9H41.33C27.6,117.612,16.43,106.442,16.43,92.712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M313.109,100.659H169.008c-4.389,0-7.947-3.558-7.947-7.947c0-4.389,3.558-7.947,7.947-7.947 h144.101c4.39,0,7.947,3.558,7.947,7.947C321.056,97.101,317.498,100.659,313.109,100.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M313.109,151.518H169.008c-4.389,0-7.947-3.558-7.947-7.947s3.558-7.947,7.947-7.947h144.101 c4.39,0,7.947,3.558,7.947,7.947S317.498,151.518,313.109,151.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M253.773,202.378h-84.766c-4.389,0-7.947-3.558-7.947-7.947s3.558-7.947,7.947-7.947h84.766 c4.39,0,7.947,3.558,7.947,7.947S258.162,202.378,253.773,202.378z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD791"
    },
    d: "M303.181,258.28c-0.33-2.455-1.783-4.615-3.934-5.845l-83.914-47.951 c-3.113-1.778-7.028-1.253-9.562,1.28c-2.533,2.533-3.059,6.451-1.28,9.562l47.951,83.914c2.556,4.472,8.871,5.324,12.519,1.676 l35.963-35.963C302.675,263.202,303.51,260.735,303.181,258.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEDEF"
    },
    d: "M300.924,253.716l-47.202,47.201l203.789,203.79c4.702,4.702,10.956,7.293,17.607,7.293 c6.651,0,12.904-2.591,17.606-7.293l11.989-11.988c9.707-9.709,9.707-25.505,0-35.214L300.924,253.716z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.089,
    y: 333.857,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 367.2337 -152.1154)",
    style: {
      fill: "#F7941E"
    },
    width: 254.294,
    height: 66.752
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC44F"
    },
    d: "M203.812,213.694c0.171,0.558,0.38,1.109,0.679,1.633l47.951,83.914 c1.229,2.15,3.39,3.605,5.846,3.933c0.352,0.047,0.705,0.07,1.054,0.07c2.094,0,4.12-0.828,5.62-2.328l13.037-13.036 L203.812,213.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M272.378,282.261l-18.656,18.656l203.789,203.79c4.702,4.702,10.956,7.293,17.607,7.293 c6.651,0,12.904-2.591,17.606-7.293l1.05-1.05L272.378,282.261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.755,
    y: 254.35,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 872.2766 401.6858)",
    style: {
      fill: "#F7941E"
    },
    width: 26.383,
    height: 254.294
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#68727E"
    },
    d: "M215.333,204.484c-3.113-1.779-7.028-1.255-9.562,1.28c-2.534,2.534-3.059,6.451-1.28,9.562 l19.955,34.921l25.809-25.809L215.333,204.484z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamMenuIcon);
export default __webpack_public_path__ + "static/media/exam-menu-icon.2750d93da05a1fd4aac83e9220776da9.svg";
export { ForwardRef as ReactComponent };